import $ from '../core/Dom';
import Viewport from '../core/Viewport';
import Dispatch from '../core/Dispatch';
import Config from '../core/Config';
import Components from '../core/Components';

import { loadFlickity, loadAxios } from './async-bundles';

const $body = $('body');
const $el = $('[data-fullscreen-slideshow]');
const $slideWrapper = $el.find('[data-fullscreen-slideshow-image-wrapper]');
const $closeBtn = $el.find('[data-fullscreen-slideshow-close]');
const $prevBtn = $el.find('[data-fullscreen-slideshow-prev]');
const $nextBtn = $el.find('[data-fullscreen-slideshow-next]');

let Flickity = null;
let Axios = null;
let slideshow = null;
let lastW = 0;

let lastEntryUid = 0;
let lastImageUid = 0;
let isOpen = false;

const initFlickity = () => {
    destroyFlickity();

    slideshow = new Flickity($slideWrapper.get(0), {
        pageDots: false,
        prevNextButtons: false,
        setGallerySize: false,
        resize: false,
        wrapAround: true,
        freeScroll: false,
        groupCells: false,
        cellAlign: 'left',
        contain: true,
        accessibility: false
    });
    
    let selectedIndex = -1;
    
    if (lastImageUid !== 0) {
        $slideWrapper.find('[data-fullscreen-slideshow-image]').each((item, i) => {
            const $item = $(item);
            if ($item.attr('data-fullscreen-slideshow-image') === lastImageUid) {
                selectedIndex = i;
            }
        });
    }
    
    if ($slideWrapper.find('[data-fullscreen-slideshow-image]').length <= 1) {
         $prevBtn.css({ display: 'none' });
         $nextBtn.css({ display: 'none' });
    } else {
         $prevBtn.css({ display: '' });
         $nextBtn.css({ display: '' });
    }

    if (selectedIndex !== -1) {
        slideshow.select(selectedIndex, true, true);
    }
};

const destroyFlickity = () => {
    if (!slideshow) {
        return;
    }

    slideshow.destroy();
    slideshow = null;

};

const insertData = data => {
    $slideWrapper.append($(data));
    Components.init($slideWrapper);

    if (Flickity === null) {
        loadFlickity(flickity => {
            Flickity = flickity;

            initFlickity();
        });
    } else {
        initFlickity();
    }
};

const load = () => {
    const url = Config.get('fullscreenSlideshowFragmentUrl') + '?uid=' + lastEntryUid;

    Axios({
        method: 'get',
        url,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest', Accept: 'text/html' },
        validateStatus: status => status >= 200 && status < 400
    }).then(res => {
        const { status, data } = res || {};

        if (status === 200 && data) {
            // Do something

            insertData(data);
        } else {
            // Do something else
        }
    }).catch((error, res) => {
        console.log(error, res);
    });
};

const open = (entryUid, imageUid) => {
    if ($el.length === 0) {
        return;
    }

    isOpen = true;
    lastEntryUid = entryUid;
    lastImageUid = imageUid;

    $slideWrapper.empty();
    $el.css({ opacity: 1, display: 'block' });

    if (Axios === null) {
        loadAxios(axios => {
            Axios = axios;
            load();
        });
    } else {
        load();
    }
};

const close = () => {
    $el.css({ opacity: 0 });

    setTimeout(() => {
        $el.css({ display: 'none' });
        destroyFlickity();
        $slideWrapper.empty();

    }, 500);
    
    isOpen = false;
};

const next = () => {
    if (slideshow) {
        slideshow.next();
    }
};

const prev = () => {
    if (slideshow) {
        slideshow.previous();
    }
};

const onBodyKeyUp = e => {
    const key = e.key || e.keyCode || e.which || null;

    if (isOpen) {
        // Arrow navigation when slideshow is open
        if (['ArrowLeft', 'Left', 37].indexOf(key) > -1) {
            if (e.preventDefault) e.preventDefault();
            prev();
            return;
        }
        if (['ArrowRight', 'Right', 39].indexOf(key) > -1) {
            if (e.preventDefault) e.preventDefault();
            next();
            return;
        }
    
        if (['Escape', 27].indexOf(key) > -1) {
            if (e.preventDefault) e.preventDefault();
            close();
        }
    }
};


const onResize = () => {
    if (lastW !== Viewport.width) {
        if (isOpen && Flickity !== null) {
            initFlickity();
        }

        lastW = Viewport.width;
    }
};

const init = () => {
    if ($el.length === 0) {
        return;
    }

    $closeBtn.on('click', close);
    $prevBtn.on('click', prev);
    $nextBtn.on('click', next);
    $body.on('keyup', onBodyKeyUp);

    Viewport.on('resize', onResize);
};

export default {
    init,
    open
};
